export function getUniqueObjectsByProperties(
  array: any,
  properties: string[],
): any {
  const seen = new Set(); // To track unique combinations of properties
  return array.filter((obj: any) => {
    // Create a unique key based on the specified properties
    const key = properties.map((prop) => obj[prop]).join('|');
    if (seen.has(key)) {
      return false; // Duplicate found, exclude from result
    }
    seen.add(key); // Mark this combination as seen
    return true; // Include in result
  });
}
